// API =>
import backEnd from "../../services/Api";
import axios, { AxiosError } from "axios";

// Types =>
import { AddToCartPayload, ServiceResult } from "./ProductInfoType";

// utils =>
import { LocalCSRFReceiver } from "../../utils/GetLocalCSRF";

// hooks =>
import { useUserStore } from "../../hooks/useUserStore";

const resolveErrorMessage = (error: unknown): string => {
    if (!axios.isAxiosError(error)) {
        return "خطای غیرمنتظره‌ای رخ داد.";
    }

    const axiosError = error as AxiosError<any>;

    if (axiosError.response) {
        const status = axiosError.response.status;
        const data = axiosError.response.data;

        if (data?.message) {
            return data.message;
        }

        switch (status) {
            case 400:
                return "درخواست نامعتبر است.";
            case 401:
            case 403:
                useUserStore.getState().setUser(null);
                localStorage.removeItem("user-storage");

                return "لطفاً وارد حساب کاربری خود شوید.";
            case 404:
                return "محصول یافت نشد.";
            case 429:
                return "تعداد درخواست‌ها بیش از حد مجاز است.";
            case 500:
                return "خطای داخلی سرور رخ داده است.";
            default:
                return "خطایی رخ داده است.";
        }
    }

    if (axiosError.request) {
        return "ارتباط با سرور برقرار نشد.";
    }

    return "خطایی در ارسال درخواست رخ داد.";
};

export const addProductToCart = async (
  payload: AddToCartPayload
): Promise<ServiceResult> => {
    try {
        const { productId, quantity = 1, colorId, variantId } = payload;

        if (!productId)
            return { success: false, message: "شناسه محصول معتبر نیست." };

        if (quantity <= 0)
            return { success: false, message: "تعداد باید بیشتر از صفر باشد." };

        const csrf = await LocalCSRFReceiver();

        const headers: Record<string, string> = {
            "Content-Type": "application/json",
        };

        if (csrf) headers["X-CSRFToken"] = csrf;

        await backEnd.post(
            "shopping-cart/items/add/",
            {
                product_id: productId,
                quantity: quantity,
                item_color: colorId,
                item_variant: variantId,
            },
            {
                headers,
            });

        return {
            success: true,
            message: "محصول با موفقیت به سبد خرید اضافه شد.",
        };

    } catch (error) {
        return { success: false, message: resolveErrorMessage(error) };
    }
};

export const addQuantity = (
    alreadyQuantity: number
): number => {
    return alreadyQuantity + 1;
}

export const minimiseQuantity = (
    alreadyQuantity: number
): number => {
    return alreadyQuantity - 1;
}

export const handleScroll = (ref: React.RefObject<HTMLDivElement | null>) => {
    if (ref.current) ref.current.scrollIntoView({ behavior: "smooth" });
}
